module.exports = __webpack_public_path__ + "img/08.a2035a9a.png";